import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-currency',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './currency.html',
})
export class CurrencyComponent {
  @Input() amount: number | null = 0;
  @Input() currencyCode: string = 'GBP'; // Default currency is GBP (British Pound Sterling)
  @Input() format: string = '1.0-0';
  @Input() showSymbol: boolean = false;
  @Input() showOnlySymbol: boolean = false;
  @Input() showOnlyNumber: boolean = false;

 
  private currencySymbols: Record<string, string> = {
    GBP: '£',
    USD: '$',
    EUR: '€',
    
  };

  get currencySymbol(): string {
    return this.currencySymbols[this.currencyCode] ?? this.currencyCode;
  }
}
